/**
 * Network Status Indicator
 * Shows online/offline status (simplified - no offline sync)
 */

import React from 'react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';

const NetworkStatus = () => {
  const { isOnline, wasOffline } = useOnlineStatus();

  // Show prominent message when coming back online
  if (wasOffline && isOnline) {
    return (
      <div className="fixed top-0 left-0 right-0 z-50 bg-green-500 text-white px-4 py-2 text-center animate-pulse">
        <span className="font-semibold">🟢 Back Online!</span>
      </div>
    );
  }

  if (isOnline) {
    return (
      <div className="fixed top-0 left-0 right-0 z-40 bg-white border-b border-gray-200 px-4 py-1.5 shadow-sm">
        <div className="flex items-center justify-between max-w-7xl mx-auto text-xs">
          <div className="flex items-center gap-2">
            <span className="flex items-center gap-1.5">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
              <span className="font-medium text-green-700">Online</span>
            </span>
          </div>
        </div>
      </div>
    );
  }

  // Offline
  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-red-500 text-white px-4 py-2 shadow-lg">
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        <div className="flex items-center gap-2">
          <div className="w-2.5 h-2.5 bg-white rounded-full"></div>
          <span className="font-semibold">Offline</span>
          <span className="text-xs opacity-90">• Please check your connection</span>
        </div>
      </div>
    </div>
  );
};

export default NetworkStatus;
